import { render, staticRenderFns } from "./PremiumSea.vue?vue&type=template&id=a7e8392e&"
import script from "./PremiumSea.vue?vue&type=script&lang=js&"
export * from "./PremiumSea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports